import { createFileRoute } from '@tanstack/react-router'
import { usePageTitle } from '../../features/page-title/pageTitle.ts'
import { LiveblogProfilesPage } from '../../features/liveblog-profiles/LiveblogProfilesPage.tsx'

export const Route = createFileRoute('/me/liveblog-profiles')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle('Liveblog profiles')
  return <LiveblogProfilesPage />
}
